import styled from 'styled-components';
import {
    SELECTORS,
} from '../../constants/index';


export const NavigationContainer = styled.div`
    ${SELECTORS} & {
        margin: 50px auto 100px auto;
    }
`;